import { theme } from "../../theme";
export const createEventFlow = {
    wrapper: {
      background: "#f7f7f7",
      alignItems: "center",
      minHeight: "100vh",
      justifyContent: "flex-start",
    },
    wizardSteps: {
      background: "#f7f7f7",
      minWidth: "250px",
      marginTop: "10px",
      marginBottom: "20px",
      '& .MuiStepConnector-alternativeLabel': {
        top: 15,
      },
      '& .MuiStepConnector-line': {
        height: "1px",
        border: 0,
        backgroundColor: "#e7e7e7",
        borderRadius: 1,
      },
    },
    root: {
      backgroundColor: "#fff",
      zIndex: 1,
      color: theme.palette.grey["800"],
      width: 30,
      height: 30,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "14px",
    },
    active: {
      color: "#fff",
      backgroundColor: "#7BB325",
      filter: "drop-shadow(0px 2px 5px rgba(120, 120, 120, 0.5))",
    },
    completed: {
      color: "#fff",
      backgroundColor: theme.palette.primary.dark,
    },
  };

  export const newEventDetails = {
    wrapper: {
      marginBottom: "20px",
    },
    formWrapper: {
      background: "#fff",
      padding: "20px",
      borderRadius: "6px",
    },
    eventLogo: {
      paddingBottom: "100%",
      display: "block",
      position: "relative",
    },
    media: {
      position: "absolute",

      left: 0,
      top: 0,
      height: "100%", //auto
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
      cursor: "pointer",
    },
    issueButton: {
      fontSize: "12px",
      textDecoration: "underline",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "none",
      },
      marginBottom: "15px",
    },
  } as const;

  export const importDataList = {
    nodataMessage: {
      color: theme.palette.text.primary,
      fontSize: "18px",
      padding: "50px 0",
      background: "#fff",
    },
    issueButton: {
      fontSize: "12px",
      textDecoration: "underline",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "none",
      },
      marginBottom: "15px",
    },
  } as const;

  export  const eventSourceSelector ={
    providersList: {
      marginTop: "20px",
    },
    providerButton: {
      paddingBottom: "100%",
      display: "block",
      position: "relative",
    },
    media: {
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%", //auto
      // maxWidth:"100%"
      // objectFit: "scale-down",
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
      cursor: "pointer",
    },
    customButton: {
      height: "6vw",
      width: "6vw",
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
      textDecoration: "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
    customButtonIcon: {
      color: theme.palette.primary.main,
      fontSize: "1.5vw",
      display: "inherit",
    },
    customButtonLabel: {
      marginTop: "5px",
      fontSize: "0.7vw",
      textTransform: "uppercase",
      color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    issueButton: {
      fontSize: "12px",
      position: "absolute",
      bottom: "20px",
      textDecoration: "underline",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "none",
      },
    },
  };
